import React from 'react';
import ListItem from './listitem';
import { Default, Mobile } from '../responsive';
import Icons, { IconNames } from './icons';

export default class VoyageList extends React.Component {
  constructor(props) {
    super(props);
    this.onClickItem = this.onClickItem.bind(this);
    this.onClickBack = this.onClickBack.bind(this);
    this.renderListItems = this.renderListItems.bind(this);

    this.state = { showDetails: false, detailItems: null, detailHeaders: null };
  }

  getClassName(baseSelector) {
    let className = baseSelector;
    const modifier = this.props.itemClassModifier;
    if (modifier) {
      className += ` ${baseSelector}--${modifier}`;
    }
    return className;
  }

  onClickItem(detailItems, detailHeaders) {
    this.setState({ showDetails: true, detailItems, detailHeaders });
  }

  onClickBack() {
    this.setState({ showDetails: false });
  }

  renderHeaderItems(headers, key, itemHighlights, renderOnlyFirstItem) {
    return (
      <ul className="list__header" key={`header${key}`}>
        <li>
          <ListItem
            tag="span"
            className={this.getClassName('list__header__item')}
            items={headers}
            itemHighlights={itemHighlights}
            renderOnlyFirstItem={renderOnlyFirstItem}
          />
        </li>
      </ul>
    );
  }

  renderListItems(item, key, itemHighlights, header, renderOnlyFirstItem, lastChanged) {
    const css = ['list__items__item'];

    if (lastChanged) {
      css.push('lastchanged');
    }

    if (item[0] === this.props.portName) {
      css.push('list__items__item-highlight');
    }

    return (
      <React.Fragment>
        <Default>
          <ListItem
            key={`item${key}`}
            tag="li"
            className={this.getClassName(css.join(' '))}
            items={item}
            headers={header}
            itemHighlights={item[0] === this.props.portName}
            renderOnlyFirstItem={renderOnlyFirstItem}
          />
        </Default>
        <Mobile>
          <ListItem
            key={`item${key}`}
            tag="li"
            className={this.getClassName(css.join(' '))}
            items={item}
            headers={header}
            itemHighlights={item[0] === this.props.portName}
            onClickItem={this.onClickItem}
            renderOnlyFirstItem={renderOnlyFirstItem}
          />
        </Mobile>
      </React.Fragment>
    );
  }

  findPortInHeader(header, selectedPort) {
    if (selectedPort === null || selectedPort === undefined) {
      return null;
    }

    if (header === selectedPort) {
      return true;
    } else {
      return false;
    }
  }

  renderItems() {
    const jsxItemsMap = new Map(); // will include headerKey and an array of list items
    const jsxHeadersMap = new Map();
    const selectedPort = this.props.portName;

    for (let i = 0; i < this.props.visits.length; i++) {
      const header = this.props.visits[i].headers;
      const visits = this.props.visits[i].visits;
      const lastChanged = this.props.visits[i].lastChanged;
      const headerKey = header.reduce((a, b) => a + b);

      const highlights = this.findPortInHeader(visits[0], selectedPort);

      if (jsxItemsMap.has(headerKey)) {
        jsxItemsMap.get(headerKey).push({ visits, key: i, lastChanged });
      } else {
        const listItems = [];
        listItems.push({ visits, key: i, lastChanged });
        jsxItemsMap.set(headerKey, listItems);
        jsxHeadersMap.set(headerKey, {
          headerItems: { header, key: i },
          highlights: highlights
        });
      }
    }

    const finalJsxMap = new Map();
    let keyIndex = 0;

    for (var [key, value] of jsxItemsMap.entries()) {
      const v = jsxHeadersMap.get(key);
      const highlights = v.highlights;
      const headerItems = v.headerItems;

      // iterates over headerKeys and replaces the headersKey with jsx, and warps the array in div
      finalJsxMap.set(
        this.renderHeaderItems(headerItems.header, headerItems.key, highlights),
        <ul key={keyIndex++} className="list__items">
          {value.map(item =>
            this.renderListItems(
              item.visits,
              item.key,
              highlights,
              undefined,
              false,
              item.lastChanged
            )
          )}
        </ul>
      );
    }

    return [...finalJsxMap]; // return it as array
  }

  renderItemsMobile() {
    const listItems = [];

    for (let i = 0; i < this.props.visits.length; i++) {
      const header = this.props.visits[i].headers;
      const visits = this.props.visits[i].visits;
      const lastChanged = this.props.visits[i].lastChanged;

      listItems.push({ visits, header, key: i, lastChanged });
    }

    return (
      <React.Fragment>
        {this.renderHeaderItems(['Port'], 0, null, true)}
        <ul className="list__items">
          {listItems.map(item =>
            this.renderListItems(item.visits, item.key, null, item.header, true, item.lastChanged)
          )}
        </ul>
      </React.Fragment>
    );
  }

  renderItemDetails() {
    const items = [...this.state.detailItems].splice(1);
    const headers = [...this.state.detailHeaders].splice(1);

    const details = items.map((key, index) => {
      return (
        <li className="voyagedetails__list__row" key={index}>
          <div className="voyagedetails__list__row__port">{headers[index]}</div>
          <div className="voyagedetails__list__row__date">{key}</div>
        </li>
      );
    });

    return (
      <div className="voyagedetails">
        <div className="voyagedetails__header">
          <Icons
            iconName={IconNames.ArrowUp}
            iconClassName={'openCloseIcon back'}
            className="openCloseWrapper"
            onClick={this.onClickBack}
          />
          <div className="voyagedetails__header__title">{this.state.detailItems[0]}</div>
        </div>
        <ul className="voyagedetails__list">
          <li className="voyagedetails__list__row">
            <div className="voyagedetails__list__row__header">Voyage No.</div>
            <div className="voyagedetails__list__row__header">Date</div>
          </li>
          {details}
        </ul>
      </div>
    );
  }

  render() {
    return (
      <div className="list voyagelist">
        {!this.state.showDetails && (
          <React.Fragment>
            <Default>{this.renderItems()}</Default>
            <Mobile>{this.renderItemsMobile()}</Mobile>
          </React.Fragment>
        )}
        {this.state.showDetails && (
          <React.Fragment>
            <Mobile>{this.renderItemDetails()}</Mobile>
          </React.Fragment>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/voyagelist.js